import React from "react";
import { MdHomeWork } from "react-icons/md";

export default function About({ VenuesDetails }) {
  return (
    <div className="details-section">
      <h4>About</h4>
      <div className="d-flex" style={{ marginBottom: 15 }}>
        <strong>
          <MdHomeWork style={{ color: "var(--primaryColor)" }} />
          <span style={{ marginLeft: 5, fontSize: 14, fontWeight: 600 }}>
            {VenuesDetails?.subcategory?.name}, {VenuesDetails?.category?.name}
          </span>
        </strong>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: VenuesDetails?.text_editor }}
      ></div>
    </div>
  );
}
